let registeredStore;

const registerStore = (store) => {
  registeredStore = store;
};

const getStore = () => registeredStore;

export { registerStore, getStore };
